export default __webpack_public_path__ + "static/media/Online Operators.f9c07ec3.svg";